import { Component, OnInit, ViewChild } from '@angular/core';
import { MessageService } from 'primeng/api';
import { IMessage } from 'src/app/shared/interfaces/message';
import { EMsessageType } from 'src/app/shared/interfaces/messageType-enum';
import { EMsgUserType } from 'src/app/shared/interfaces/msgUserType-enum';
import { ISearchBody } from 'src/app/shared/interfaces/searchBody';
import { IUser } from 'src/app/shared/interfaces/user';
import { ModalComponent } from 'src/app/shared/modals/modal.component';
import { ApiService } from 'src/app/shared/services/api.service';

@Component({
  selector: 'app-message',
  templateUrl: './message.component.html',
  styleUrl: './message.component.css'
})
export class MessageComponent implements OnInit {

  messageList: IMessage[];
  messageType: any;
  msgId: any;
  isPrivate: boolean = true;
  searchInp: ISearchBody = {
    title: '',
    pageIndex: 0,
    pageSize: 0
  };
  userSearch: ISearchBody = {
    title: ''
  };
  messageModel: IMessage = {
    id: 0,
    type: null,
    messageType: null,
    text: '',
    userId: null
  }
  userList: IUser[];
  userSuggestion: any[] = [];
  selectedItem: any = null;
  fullName: any;

  first: number = 0 ;
  rows: number = 10;
  pageSize = 10;  
  currentpage = 1;
  collectionSize: number = 10;

  @ViewChild('modal') modal!: ModalComponent;
  @ViewChild('del') del!: ModalComponent;


  constructor(private apiService: ApiService,
              private messageService: MessageService
  ) {}

  ngOnInit(): void {
    this.getMessagesList(0);
  }

  getUsers() {
    if (this.messageType == 'public-user') {
      this.messageModel.type = EMsgUserType.Client;
      this.messageModel.messageType =  EMsessageType.Group;
    } else if (this.messageType == 'public-doctor') {
      this.messageModel.type = EMsgUserType.Doctor;
      this.messageModel.messageType =  EMsessageType.Group;
    } else if (this.messageType == 'private-user') {
      this.isPrivate = false;
      this.messageModel.type = EMsgUserType.Client;
      this.messageModel.messageType =  EMsessageType.Private;

      // this.apiService.apiCall('post', '/api/User/GetAll', this.userSearch).subscribe((res: any) => {
      //   console.log(res);
      //   this.userList = res.body.model;
      // })

    } else {
      this.isPrivate = false;
      this.messageModel.type = EMsgUserType.Doctor;
      this.messageModel.messageType =  EMsessageType.Private;
    }

  }

  getMessagesList(page) {
    this.searchInp = {
      title: this.searchInp.title,
      pageIndex: page+1,
      pageSize: this.pageSize
    };
    console.log(this.searchInp);
    
    this.apiService.apiCall('post', '/api/Message/GetAll', this.searchInp).subscribe((res: any) => {
      console.log(res);
       this.messageList = res.body.model;
       this.collectionSize = res.body.collectionSize;
    })

  }

  search(event) {
    let filter: any[] = [];
    this.userSearch.title = event.query;
  
    this.apiService.apiCall('post', '/api/User/GetAllWithOutPagination', this.userSearch).subscribe((res: any) => {
      console.log(res);
      this.userList = res.body.model;
  
      for (let i = 0; i < this.userList.length; i++) {
        let user = this.userList[i];
        user.fullName = `${user.firstName} ${user.lastName}`; // Add fullName property
        filter.push(user);
      }
  
      this.userSuggestion = filter;
      console.log('*/*/*/', this.userSuggestion);
    });
  }

  onItemSelected($event: any) {
    console.log($event);
    this.messageModel.userId = $event.value.userInfoId;
  }

  sendNewMessage() {
    
    console.log(this.messageModel);

    this.apiService.apiCall('post', '/api/Message/Add', this.messageModel).subscribe((res: any) => {
      console.log(res);

      if (res.body.isSuccess == true) {
        this.modal.close();

        this.messageService.add({severity: 'success', summary:  'موفق', detail: 'ارسال پیام با موفقیت انجام شد' });
        this.messageList.push(this.messageModel);
      } else {
        this.messageService.add({severity: 'error', summary:  'خطا', detail: res.body.message });
      }
      
    })
  }

  deleteMessage() {
    this.apiService.apiCall('post', '/api/Message/Delete/' + this.msgId).subscribe((res: any) => {
      console.log(res);
      if (res.body.isSuccess == true) {
        this.del.close();

        this.messageService.add({severity: 'success', summary:  'موفق', detail: 'حذف پیام با موفقیت انجام شد' });

        const temp = this.messageList.filter(item => item.id != this.msgId);
        this.messageList = temp;
      } else {
        this.messageService.add({severity: 'error', summary:  'خطا', detail:  res.body.message});
      }
    })
  }

}
